import { Navigate, Route, Routes } from 'react-router-dom';
import { useAuth } from './lib/auth';
import { RefDataProvider } from './lib/refdata';
import { Login } from './pages/Login';
import { SignInComplete } from './pages/SignInComplete';
import { MinistryDashboard } from './pages/ministry/Dashboard';
import { Commitments } from './pages/ministry/Commitments';
import { Invoices } from './pages/ministry/Invoices';
import { Vouchers } from './pages/ministry/Vouchers';
import { Procurement } from './pages/ministry/Procurement';
import { Assets } from './pages/ministry/Assets';
import { FinanceOverview } from './pages/finance/Overview';
import { CoaAdmin } from './pages/finance/CoaAdmin';
import { Appropriations } from './pages/finance/Appropriations';
import { Warrants } from './pages/finance/Warrants';
import { BudgetVsActual } from './pages/finance/BudgetVsActual';
import { BudgetPrep } from './pages/finance/BudgetPrep';
import { Virements } from './pages/finance/Virements';
import { Debt } from './pages/finance/Debt';
import { TreasuryQueue } from './pages/treasury/Queue';
import { Batches } from './pages/treasury/Batches';
import { Reconciliation } from './pages/treasury/Reconciliation';
import { TsaPosition } from './pages/treasury/TsaPosition';
import { Revenue } from './pages/treasury/Revenue';
import { SeyPay } from './pages/treasury/SeyPay';
import { Establishment } from './pages/payroll/Establishment';
import { Runs } from './pages/payroll/Runs';
import { Suppliers } from './pages/Suppliers';
import { Shell } from './ui/Shell';

export function App() {
  const { persona } = useAuth();

  if (!persona) {
    return (
      <Routes>
        <Route path="/signin/complete" element={<SignInComplete />} />
        <Route path="*" element={<Login />} />
      </Routes>
    );
  }

  return (
    <RefDataProvider>
      <Routes>
        <Route path="/" element={<Navigate to={`/${persona.workspace}`} replace />} />

        <Route
          path="/ministry"
          element={
            <Shell
              title={persona.org}
              items={[
                { to: '/ministry', label: 'Budget dashboard', icon: '◫' },
                { to: '/ministry/commitments', label: 'Commitments & POs', icon: '◇' },
                { to: '/ministry/invoices', label: 'Supplier invoices', icon: '▤' },
                { to: '/ministry/vouchers', label: 'Payment vouchers', icon: '✓' },
                { to: '/ministry/procurement', label: 'Procurement', icon: '▧' },
                { to: '/ministry/assets', label: 'Fixed Assets', icon: '▣' },
                { to: '/ministry/suppliers', label: 'Suppliers', icon: '⌂' },
              ]}
            />
          }
        >
          <Route index element={<MinistryDashboard />} />
          <Route path="commitments" element={<Commitments />} />
          <Route path="invoices" element={<Invoices />} />
          <Route path="vouchers" element={<Vouchers />} />
          <Route path="procurement" element={<Procurement />} />
          <Route path="assets" element={<Assets />} />
          <Route path="suppliers" element={<Suppliers />} />
        </Route>

        <Route
          path="/finance"
          element={
            <Shell
              title="Budget Division"
              items={[
                { to: '/finance', label: 'National overview', icon: '◫' },
                { to: '/finance/bva', label: 'Budget vs Actual', icon: '◧' },
                { to: '/finance/budget-prep', label: 'Budget Preparation', icon: '✎' },
                { to: '/finance/appropriations', label: 'Appropriations', icon: '≣' },
                { to: '/finance/warrants', label: 'Warrants & allotments', icon: '✦' },
                { to: '/finance/virements', label: 'Virements', icon: '⇌' },
                { to: '/finance/debt', label: 'Public Debt', icon: '◐' },
                { to: '/finance/coa', label: 'Chart of accounts', icon: '⌗' },
                { to: '/finance/suppliers', label: 'Suppliers', icon: '⌂' },
              ]}
            />
          }
        >
          <Route index element={<FinanceOverview />} />
          <Route path="bva" element={<BudgetVsActual />} />
          <Route path="budget-prep" element={<BudgetPrep />} />
          <Route path="appropriations" element={<Appropriations />} />
          <Route path="warrants" element={<Warrants />} />
          <Route path="virements" element={<Virements />} />
          <Route path="debt" element={<Debt />} />
          <Route path="coa" element={<CoaAdmin />} />
          <Route path="suppliers" element={<Suppliers />} />
        </Route>

        <Route
          path="/treasury"
          element={
            <Shell
              title="Treasury & Central Bank"
              items={[
                { to: '/treasury', label: 'Voucher queue', icon: '☰' },
                { to: '/treasury/batches', label: 'Payment batches', icon: '⇶' },
                { to: '/treasury/reconciliation', label: 'Reconciliation', icon: '⇄' },
                { to: '/treasury/tsa', label: 'TSA position', icon: '◎' },
                { to: '/treasury/revenue', label: 'Revenue & Cash Position', icon: '≈' },
                { to: '/treasury/seypay', label: 'SeyPay & Settlements', icon: '⇅' },
                { to: '/treasury/suppliers', label: 'Supplier registry', icon: '⌂' },
              ]}
            />
          }
        >
          <Route index element={<TreasuryQueue />} />
          <Route path="batches" element={<Batches />} />
          <Route path="reconciliation" element={<Reconciliation />} />
          <Route path="tsa" element={<TsaPosition />} />
          <Route path="revenue" element={<Revenue />} />
          <Route path="seypay" element={<SeyPay />} />
          <Route path="suppliers" element={<Suppliers />} />
        </Route>

        <Route
          path="/payroll"
          element={
            <Shell
              title="Payroll & Establishment"
              items={[
                { to: '/payroll', label: 'Establishment', icon: '◈' },
                { to: '/payroll/runs', label: 'Payroll runs', icon: '⟳' },
              ]}
            />
          }
        >
          <Route index element={<Establishment />} />
          <Route path="runs" element={<Runs />} />
        </Route>

        <Route path="*" element={<Navigate to={`/${persona.workspace}`} replace />} />
      </Routes>
    </RefDataProvider>
  );
}
